var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import moment from "moment";
// icons
import CustomIllustration from "@frameworks/shared-library/assets/images/features/Markets/Pms/custom-Illustration.svg";
// stylesheet
import "@frameworks/shared-library/stylesheets/components/TransactionJourney/MandateType/MandateType.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
// components
import InputComponent from "../../../components/InputComponent";
import RadioButton from "@frameworks/web/components/generic/radioButton";
import { validateOptions } from "../../../constants/constant";
import { emailRegex } from "@frameworks/salesjourney/utils/regex";
function ClientDetails(_a) {
    //
    var selectedOption = _a.selectedOption, mobileNo = _a.mobileNo, selectedDate = _a.selectedDate, email = _a.email, onSelectedOptionChange = _a.onSelectedOptionChange, onMobileNoChange = _a.onMobileNoChange, onSelectedDateChange = _a.onSelectedDateChange, onEmailChange = _a.onEmailChange, isError = _a.isError, setIsError = _a.setIsError, error = _a.error, setError = _a.setError, emailError = _a.emailError, setEmailError = _a.setEmailError;
    var calendarRef = useRef(null);
    var clientDetails = useSelector(function (state) { return state.markets.AifPms; }).clientDetails;
    var _b = __read(useState(), 2), formData = _b[0], setFormData = _b[1];
    var countryCode = (formData === null || formData === void 0 ? void 0 : formData.countryprefix) ? formData === null || formData === void 0 ? void 0 : formData.countryprefix : "91";
    var onChangeMobile = function (e) {
        var value = e.target.value.replace(/\D/g, "");
        if (value.length > 0 && value.length < 10) {
            handleError("mobile", "Please enter a valid Mobile Number");
        }
        else {
            setError({});
        }
        if (isError) {
            setIsError(false);
        }
        onMobileNoChange(value, countryCode);
    };
    var onChangeEmail = function (e) {
        var value = e.target.value;
        if (!emailRegex.test(value) && value.length > 0) {
            setEmailError(true);
        }
        else {
            setEmailError(false);
        }
        onEmailChange(e.target.value);
    };
    var onChangeValidateBy = function (e) {
        onMobileNoChange("", "");
        onEmailChange("");
        setIsError(false);
        setError({});
        setEmailError(false);
        onSelectedOptionChange(e.target.value);
    };
    var renderInput = function () {
        switch (selectedOption) {
            case "mobile":
                return (React.createElement("div", null,
                    React.createElement("div", { className: "verify-client ".concat((isError || (error === null || error === void 0 ? void 0 : error.mobile)) && "error") },
                        React.createElement("div", { className: "country-code" },
                            React.createElement("p", { className: "Roboto_14_400" }, "91"),
                            React.createElement("span", { className: "edel-icon-arrow-down icon" })),
                        React.createElement("input", { placeholder: "Enter Mobile Number", disabled: false, value: mobileNo, className: "mobile-input Roboto_14_400", onChange: onChangeMobile, maxLength: 10 })),
                    error && (error === null || error === void 0 ? void 0 : error.mobile) && (React.createElement("p", { className: "DMSanN_13_400 error-text" }, error === null || error === void 0 ? void 0 : error.mobile)),
                    isError && mobileNo && (React.createElement("p", { className: "DMSanN_13_400 error-text" }, "Mobile number does not match Client records"))));
            case "dob":
                return (React.createElement("div", { className: "calendar-container mt-3" },
                    React.createElement(DatePicker, { ref: calendarRef, className: "calendar", placeholderText: "Enter Date of Birth", dateFormat: "d-MMM-yyyy", showYearDropdown: true, selected: selectedDate ? new Date(selectedDate) : undefined, onSelect: function (date) {
                            onSelectedDateChange(moment(date).format("YYYY/MM/DD"));
                        }, maxDate: new Date(), onChange: function (date) { return onSelectedDateChange(date); } }),
                    React.createElement("p", { className: "calendar-icon" },
                        React.createElement("i", { className: "edel-icon-calendar-rounded", onClick: function () {
                                calendarRef.current.setOpen(true);
                            } }))));
            case "email":
                return (React.createElement("div", { className: "mt-3" },
                    React.createElement(InputComponent, { label: "", placeholder: "Email", helperText: "", type: "email", value: email, onChangeEvent: onChangeEmail }),
                    emailError && (React.createElement("p", { className: "DMSanN_13_400 error-text" }, "Please enter valid email"))));
            default:
                return null;
        }
    };
    var handleError = function (field, value) {
        setError(function (error) {
            var _a;
            return __assign(__assign({}, error), (_a = {}, _a[field] = value, _a));
        });
    };
    return (React.createElement("div", { className: "aif-pms-sidebar-body add-client overflow-scroll aifpms-journey" },
        React.createElement("div", { className: "custom-tabs-container" },
            React.createElement("div", { className: "rounded add-client-height width-375 position-relative v-client-details-section mb-5" },
                React.createElement("div", { className: "form-group" },
                    React.createElement(InputComponent, { label: "PAN", placeholder: "", helperText: "", disabled: true, value: clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.pan })),
                React.createElement("div", { className: "form-group" },
                    React.createElement(InputComponent, { label: "Client Name", placeholder: "", helperText: "", disabled: true, value: clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.clientName })),
                React.createElement("div", { className: "primary-mandate-radio-btns-container d-flex" }, (validateOptions === null || validateOptions === void 0 ? void 0 : validateOptions.length) > 0 &&
                    validateOptions.map(function (item, count) { return (React.createElement(RadioButton, { name: "validateBy", list: item, onChange: onChangeValidateBy, selected: selectedOption, key: count, className: "common-radio-button selected-desk-tab" })); })),
                React.createElement("div", { className: "selected-form-group" }, renderInput())),
            React.createElement("img", { src: CustomIllustration, className: "position-absolute object-fit-contain", width: 150, height: 152, style: { bottom: "46px", right: "15px" } }))));
}
export default ClientDetails;
